import { Link, useHistory } from 'react-router-dom'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'

function NoAccessToModuleDialog() {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Dialog open>
      <DialogTitle>{t('dialogNoAccess.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('dialogNoAccess.contentText')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={history.goBack}>{t('dialogNoAccess.cancel')}</Button>
        <Button
          component={Link}
          color='primary'
          sx={{
            // Semantic-UI messes with the styling of links styled as MUI buttons. Because of this
            // we need to specifically add the color with `!important`.
            color: theme => `${theme.palette.getContrastText(theme.palette.primary.main)} !important`,
            // MUI's styling doesn't account for having two different elements as dialog actions. Since we both have a
            // button and an anchor element we need to add margin left ourselves.
            marginLeft: 1
          }}
          to='/settings/lease-company'
          variant='contained'
        >
          {t('dialogNoAccess.go_to_lease_company')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default NoAccessToModuleDialog
